export default [
  { id: "S", description: "Servicio aereo regular" },
  { id: "N", description: "Transporte aereo no regular" },
  { id: "G", description: "Aviacion general" },
  { id: "M", description: "Aviacion militar" },
  { id: "X", description: "Otra categoria" },
];
